export const creatorFinancialKeys = {
  all: ["creator-financial"] as const,
  bankAccounts: () => [...creatorFinancialKeys.all, "bank-accounts"] as const,
  receivableSnapshots: (params?: unknown) =>
    [...creatorFinancialKeys.all, "receivable-snapshots", params] as const,
  payments: (params?: unknown) =>
    [...creatorFinancialKeys.all, "payments", params] as const,
  receiptRequests: (params?: unknown) =>
    [...creatorFinancialKeys.all, "receipt-requests", params] as const,
};
